<template>
  <div>
    <nav-bar/>
    <aside-menu :menu="menu"/>
    <router-view style="padding-top: 4rem; min-height: 100vh;"/>
    <!-- <footer-bar/> -->
  </div>
</template>

<script>
// @ is an alias to /src

import NavBar from '@/components/NavBar'
import AsideMenu from '@/components/AsideMenu'
// import FooterBar from '@/components/FooterBar'
import CredentialsService from '@/services/CredentialsService.js'

export default {
  name: 'home',
  components: {
    // FooterBar,
    AsideMenu,
    NavBar
  },
  computed: {
    roles () {
      return CredentialsService.getUser().roles
    },
    isOnlyJudge () {
      return (this.roles.length === 1 && this.roles.some(({ name }) => name === 'judge'))
    },
    menu () {
      if (this.isOnlyJudge) {
        return [
          'Menú',
          this.getJudgeMenu()
        ]
      }
      return [
        'Menú',
        this.getFullMenu()
      ]
    }
  },
  methods: {
    getFullMenu () {
      return [
        {
          to: '/resumen',
          icon: 'desktop-mac',
          label: 'Resumen'
        },
        {
          to: '/ranking',
          icon: 'podium',
          label: 'Ranking'
        },
        {
          label: 'Evaluaciones',
          icon: 'clipboard-check',
          to: '/evaluaciones'
        },
        {
          label: 'Yeguada',
          icon: 'horseshoe',
          to: '/caballos'
        },
        {
          label: 'Jinetes',
          icon: 'account-group',
          to: '/jinetes'
        },
        {
          label: 'Asignaciones',
          icon: 'ballot',
          to: '/asignaciones'
        },
        {
          label: 'Trabajo Diario',
          icon: 'calendar-multiselect',
          menu: [
            {
              label: 'Calendario de Trabajo',
              to: '/trabajo-diario'
            },
            {
              label: 'Bloqueo de Días',
              to: '/bloqueo-dias'
            }
          ]
        },
        {
          label: 'Herraje',
          icon: 'toolbox-outline',
          to: '/servicios-herraje'
        },
        {
          label: 'Reportes',
          icon: 'file-chart',
          to: '/reportes'
        },
        {
          label: 'Usuarios',
          icon: 'account-group',
          to: '/usuarios'
        },
        {
          label: 'Visores',
          icon: 'monitor-eye',
          to: '/visores'
        }
      ]
    },
    getJudgeMenu () {
      return [
        {
          label: 'Evaluaciones',
          icon: 'clipboard-check',
          to: '/evaluaciones'
        }
      ]
    }
  },
  created () {
    let user = CredentialsService.getUser()
    this.$store.commit('user', {
      name: `${user.name} ${user.lastname !== null ? user.lastname : ''}`,
      email: `${user.email}`,
      avatar: '/data-sources/avatars/annie-spratt-121576-unsplash.jpg'
    })
  }
}
</script>
